export const AS_VIDEOS_URL = 'http://www.adultswim.com/videos/';
export const EMBED_CODE_L = '<iframe width="560" height="315" src="';
export const EMBED_CODE_R = '" frameborder="0" allowfullscreen></iframe>';
export const EMBED_URL = 'http://www.adultswim.com/utilities/embed/';
export const FACEBOOK_SHARE_URL = 'https://facebook.com/sharer.php?u=';
export const FETCH_DATA = {
	'fields': 'title,type,duration,collection_title,images,stream,segments,title_id'
};
export const HLS_MIME_TYPE = 'application/vnd.apple.mpegurl';
export const LOCALSTORAGE_MUTED = 'as-player:muted';
export const LOCALSTORAGE_CAPTIONS = 'as-player:captions';
export const PROBLEM_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2016/09/26/problem-1.jpg';
export const NOT_FOUND_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2017/07/27/404-compressor.jpg';
export const FORBIDDEN_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2017/07/27/geoBlock2.jpg';
export const RECONNECTING_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2016/09/26/reconnecting.jpg';
export const SERVICE_URL = '/videos/api/v2/videos/';
export const TUMBLR_SHARE_URL = 'https://www.tumblr.com/share/link?url=';
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet?url=';
export const NOISE = 'https://s.cdn.turner.com/adultswim/big/audio/as-player/Chris_Screams.mp3';
export const OMNITURE_VIDEO_PREROLL = 'video-preroll';
export const OMNITURE_VIDEO_MIDROLL_START = 'video-midroll-start';
export const OMNITURE_VIDEO_MIDROLL_COMPLETE = 'video-midroll-complete';
export const OMNITURE_VIDEO_POSTROLL_START = 'video-postroll-start';
export const OMNITURE_VIDEO_POSTROLL_COMPLETE = 'video-postroll-complete';


// WEBPACK FOOTER //
// ./src/config/player.js